import React from 'react';
import CusAutocomplete from './CusAutocomplete';
import { useAppSelector } from '../../store';

export default function UserAutoComplete({ userId, groupId, setUserId, options }) {
  const groupHash = useAppSelector((state) => state.user.group.hash);
  const group = groupHash[groupId];

  return (
    <CusAutocomplete
      label={'User'}
      options={options}
      toolTipText="Select a game group first so that the group's players will appear here."
      disabled={!group?.game}
      value={options?.find((el) => el.value == userId)?.label}
      onChange={(_, choseItem) => {
        const value = choseItem ? choseItem.value : 0;
        setUserId(value);
      }}
    />
  );
}
